import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { REQUEST_FIN_COCKPIT } from 'partner360/features/financialCockpit/constants'
import { selectIsNetworkDebugUser } from 'shared/lib/networkDebug'

import { fetchFinancialCockpitData } from '../../api'
import { IFetchFinancialCockpitDataParams } from '../../api/types'

export const requestFinancialCockpitData = createAsyncThunk(
  REQUEST_FIN_COCKPIT,
  (params: IFetchFinancialCockpitDataParams, { dispatch, getState }) =>
    fetchFinancialCockpitData({
      ...params,
      dispatch,
      debug: selectIsNetworkDebugUser(getState()),
    })
)
